export default __webpack_public_path__ + "static/media/img-0037.2ea287f9.png";